var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{key:"add",staticStyle:{"width":"97%"},attrs:{"data":_vm.compare,"border":""}},[_c('el-table-column',{attrs:{"label":_vm.title,"prop":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"内容","prop":"after"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{domProps:{"innerHTML":_vm._s(scope.row.after)}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567b0f0d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/recoder/add_pay.vue
// module id = 2380
// module chunks = 0